import { BodyText } from "@/components/ui";

export const EncounterEndMessage = () => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center">
      <BodyText size="sm" textColor="primary" italic>
        Encounter ended.
      </BodyText>
    </div>
  );
};
